import { RootState } from '../..';

export const listResultRecognizeSelector = (state: RootState) => state.reports.resultRecognizeData;

export const listResultCountSelector = (state: RootState) => state.reports.resultListCount;
